import { client as request } from "@/api/request";
import ExpensesReport from "../usecases/expenses-report";

export interface GetExpensesReportQuery {
  month: string; // yyyy-MM
  projectId?: string;
  monthOptions?: string;
  companyId?: string;
  companyType?: string;
  staffId?: string;
  vendorId?: string;
}

/**
 * 経費レポートを取得する
 */
export function getExpensesReport(
  query: GetExpensesReportQuery
): Promise<ExpensesReport> {
  const response = request.get("get_expense_report.php", query);
  return response;
}
